import styled from 'styled-components'
import { containerDefault } from '../../lib/styles/Container'
import { typoHeading3, typoParagraph } from '../../lib/styles/Typography'

export const Styled = {
  Wrapper: styled.div`
    ${containerDefault}
    margin: 3rem auto;
    padding: 1.5rem 0;
  `,
  Headline: styled.div`
    ${typoHeading3}
    margin-bottom: 0.5rem;
  `,
  Description: styled.div`
    ${typoParagraph}
    max-width: 36rem;
    margin-bottom: 2rem;
  `,
}
